import { Routes } from '@all-hands-hq/plex-graphql-schema';
import amplitude from 'amplitude-js';
import { useEffect, useState } from 'react';

import { useGetLoggedInUserQuery } from '../graphql/queries/GetLoggedInUser';

export function useSetupAnalytics(): boolean {
  const { data, loading } = useGetLoggedInUserQuery({ variables: {} });
  const [analyticsDone, setAnalyticsDone] = useState<boolean>(false);
  useEffect(() => {
    if (!loading) {
      fetch(Routes.AMPLITUDE_API_KEY_PATH)
        .then((res) => res.json())
        .catch(() => {
          console.error('could not get amplitude auth token');
          return { token: null };
        })
        .then((resJSON) => {
          const token: string = resJSON.token;
          if (token) {
            const user = data?.currentUser;
            const amplitudeConfig = { includeReferrer: true };
            if (user) {
              amplitude.init(token, user.id, amplitudeConfig);
              if (user.domain) {
                amplitude.setUserProperties({ domainName: user?.domain?.orgName, domainId: user?.domain?.id });
              }
            } else {
              amplitude.init(token, undefined, amplitudeConfig);
            }
          }
        })
        .then(() => setAnalyticsDone(true));
    }
  }, [data, loading]);
  return analyticsDone;
}
